export const TOKENMETRICS_REQUEST = "TOKENMETRICS_REQUEST";
export const TOKENMETRICS_SUCCESS = "TOKENMETRICS_SUCCESS";
export const TOKENMETRICS_FAILURE = "TOKENMETRICS_FAILURE";